import { Injectable } from '@angular/core';
import { IWebApiProxy, WebApiProxyFactoryService } from 'ssi-framework';
import { environment } from 'src/environments/environment';
@Injectable()
export class CandidateService {
    private readonly proxy: IWebApiProxy;
    constructor(private proxyFactory: WebApiProxyFactoryService) {
    }
    
}